var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-wrapper",style:(_vm.style)},[(_vm.title)?_c('h2',[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),(_vm.anchor)?_c('DocsAnchorTarget',{attrs:{"anchor":_vm.anchor}}):_vm._e()],1):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }